(ns frontend.ux-overhaul.listing.task.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.updates.entity-scope :as entity-scope]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.task.event :as task-event]
            [frontend.state.current-session :as session]
            [frontend.view.grid.tasks-grid.events :as tasks-events]
            [frontend.view.modals.activity-entity-editor.view :as activity-entity-editor]
            [frontend.view.modals.events :as modals]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "task-listing")

(defn- open-task!
  "activity-entity-editor's view resolves its :entity-id prop by reading
   @session/entities directly (a plain map lookup, no fetch) - it renders
   nothing at all (no error, just a closed-looking modal) for a task that
   was never individually hydrated into that legacy cache, which is exactly
   the case for every row sourced from this OpenSearch-backed listing.
   entity-scope/fetch-once! merges the entity into that cache on demand
   before opening, the same pattern frontend.view.entity/attempt-move-to-stage!
   uses to hydrate session ahead of its own session-reading modals.

   A webentry or email task is not edited like a plain task: the legacy grid sent
   it to its resolution flow, and so does this. The type is read from the
   hydrated task, because an index row may not carry `:task/type` or
   `:task/data`. When the type is unknown the task opens in the editor."
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (let [open-editor! (fn []
                         (modals/open-modal!
                          activity-entity-editor/modal-key
                          {:entity-id            entity-id
                           :on-success-callback! (fn [response]
                                                   ;; Update the session copy to the saved
                                                   ;; data, then refresh the listing.
                                                   (entity-scope/hydrate!
                                                    {:entity-id entity-id
                                                     :on-done   (fn [] nil)})
                                                   (rf/dispatch [::task-event/task-saved
                                                                 {:listing-id listing-id
                                                                  :response   response}]))}))
          open! (fn []
                  (let [task (get @session/entities entity-id)]
                    (case (:task/type task)
                      :task.type/webentry (tasks-events/handle-webentry task)
                      :task.type/email (tasks-events/handle-email task)
                      (open-editor!))))]
      (entity-scope/fetch-once! {:entity-id entity-id
                                 :on-done (fn [_entities] (open!))
                                 :on-error (fn [_error] (open-editor!))}))))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/task
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :task
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-task
                                 :label    (loc/tr :create-task)
                                 :visible? true
                                 :enabled? true
                                 :event    [::task-event/create-task {:listing-id listing-id}]}
                                {:id                  :bulk-edit-tasks
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::task-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-tasks
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::task-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-tasks
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::task-event/export-grid {:listing-id listing-id}]}
                                (menu-actions/landing-page-action {:view-id :tasks-grid})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :tasks)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.task/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::task-event/create-task {:listing-id listing-id}])
         :on-row-clicked           open-task!
         :on-card-clicked          open-task!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/task}]])}))
